import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Avatar3D } from "@/components/Avatar3D";
import { McGiftAlert } from "@/components/McGiftAlert";

const card = (border, glow) => ({ background: "rgba(10,10,10,0.85)", border: `1px solid ${border}`, boxShadow: `0 0 24px ${glow}` });
const Chip = ({ emoji, label, value, color }) => (
  <div className="flex items-center gap-2 rounded-xl px-3 py-2" style={{ background: "rgba(10,10,10,0.82)", border: `1px solid ${color}88`, boxShadow: `0 0 18px ${color}55` }}>
    <span style={{ fontSize: 26 }}>{emoji}</span>
    <div className="leading-tight"><div className="text-[9px] tracking-widest font-800" style={{ color, fontFamily: "Outfit, sans-serif" }}>{label}</div><div className="text-white text-lg font-800" style={{ fontFamily: "Outfit, sans-serif" }}>{value}</div></div>
  </div>
);
const Feed = () => (
  <div className="flex flex-col gap-1.5 items-start">
    {[["🍪", "mikakutv found a cookie!", "#f0b429"], ["🎣", "sprinklefan caught a 42cm Salmon!", "#38bdf8"], ["🎉", "raidersguild raided with 12 viewers!", "#FF3366"]].map(([e, t, c]) => (
      <div key={t} className="rounded-xl px-3 py-1.5 text-white text-sm flex items-center gap-2" style={{ background: "rgba(10,10,10,0.85)", border: `1px solid ${c}66` }}><span>{e}</span><span>{t}</span></div>
    ))}
  </div>
);
const AvatarMock = ({ layout }) => {
  const [cfg, setCfg] = useState(null);
  useEffect(() => { api.get("/avatar/config").then((r) => setCfg(r.data)).catch(() => {}); }, []);
  const h = cfg?.framing === "face" ? 420 : cfg?.framing === "half" ? 500 : 560;
  if (!cfg?.model_url) return <div className="flex items-center justify-center rounded-2xl text-white/70 text-sm" style={{ width: 420, height: 560, border: "1px dashed rgba(52,211,153,0.6)", background: "rgba(52,211,153,0.06)" }}>🧍 3D avatar (upload a model on the Avatar tab)</div>;
  return <Avatar3D modelUrl={cfg.model_url} cfg={cfg} emotion="happy" width={420} height={h} testid="overlay-mock-avatar" />;
};

/** Real-looking, full-size previews of each overlay element (scaled down by the editor to fit its canvas). */
export const OverlayMock = ({ kind, layout }) => {
  switch (kind) {
    case "now_playing":
      return (
        <div className="flex items-center gap-3 rounded-2xl px-4 py-3" style={card("rgba(255,51,102,0.5)", "rgba(255,51,102,0.35)")}>
          <div className="w-14 h-14 rounded-full" style={{ border: "2px solid #FF3366", background: "conic-gradient(#ff3366,#7c3aed,#38bdf8,#ff3366)" }} />
          <div className="max-w-[260px]"><div className="text-[10px] tracking-widest font-800" style={{ color: "#FF3366", fontFamily: "Outfit, sans-serif" }}>♪ NOW PLAYING</div><div className="text-white text-sm font-medium truncate">Nightcore - Live A Lie (Lyrics)</div></div>
        </div>
      );
    case "stash":
      return <div className="flex items-center gap-2"><Chip emoji={layout?.stash_jar_emoji || "🫙"} label={layout?.stash_jar_label || "Cookie Jar"} value="128" color="#f0b429" /><Chip emoji={layout?.stash_tray_emoji || "🧁"} label={layout?.stash_tray_label || "Cupcake Tray"} value="12" color="#FF3366" /></div>;
    case "event_feed":
      return <Feed />;
    case "slots":
      return (
        <div className="rounded-xl px-4 py-3 max-w-sm" style={card("#FF3366", "#FF336655")}>
          <div className="text-[10px] font-800 tracking-widest mb-1" style={{ color: "#FF3366", fontFamily: "Outfit, sans-serif" }}>🎰 SLOTS</div>
          <div className="text-white text-sm font-medium leading-snug">mikakutv spins… 🍒 🍒 🍒 — JACKPOT! +50 Sprinkles</div>
        </div>
      );
    case "mc_gift":
      return <McGiftAlert testid="mock-mc-gift" ev={{ username: "mikakutv", item: "5 Diamonds", item_kind: "give", player: "PancakeCupCake_", on_pancake: true, note: "go pancake!", source: "donation", reaction: "Waaah diamonds?! You're the best, thank youuu!" }} />;
    case "avatar":
      return <AvatarMock layout={layout} />;
    default:
      return null;
  }
};
